import PropTypes from 'prop-types'
import classNames from 'classnames'

import ExtraDetails from './extra-details'
import Requirements from './requirements'
import About from './about'
import FAQs from '../../faqs'

import { useBreakpoint } from '../../../../hooks/breakpoint'

const Body = ({ course, integrationSettings, ...attrs }) => {
  const breakpoint = useBreakpoint()

  return <section
    className={
      classNames([
        'py-5',
        'md:pt-20'
      ])
    }>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            '-mx-4'
          ])
        }>
        <div
          className={'px-4 flex-none'}
          style={{
            flexBasis: breakpoint.mdAndUp ? '66.666666%' : '100%'
          }}>
          <ExtraDetails
            course={course}
            className={breakpoint.mdAndUp ? 'mb-20' : 'mb-10'} />

          <Requirements
            course={course}
            className={breakpoint.mdAndUp ? 'mb-20' : 'mb-10'} />

          <About
            course={course}
            className={breakpoint.mdAndUp ? 'mb-20' : 'mb-10'} />

          <FAQs
            title={course.faqTitle}
            items={course.faqList}
            className={breakpoint.mdAndUp ? 'mb-20' : 'mb-10'}
            titleAttrs={{
              className: classNames([
                'mb-4'
              ])
            }} />
        </div>
      </div>
    </div>
  </section>
}

Body.propTypes = {
  course: PropTypes.object,
  integrationSettings: PropTypes.object
}

export default Body
